module.exports = __webpack_public_path__ + "media/icons/bulb-69d14f60.png";